type IWindowFlutterBridge = Required<Window>['flutter_inappwebview'];

const callFlutterBridgeInterface = async <TInterfaceName extends string, TInterfaceParams extends any[] = []>(
  interfaceName: TInterfaceName,
  ...interfaceParams: TInterfaceParams
) => {
  try {
    if (
      window.flutter_inappwebview &&
      typeof window.flutter_inappwebview.callHandler === 'function'
    ) {
      return await window.flutter_inappwebview.callHandler(interfaceName, ...interfaceParams);
    }
  } catch (e) {
    console.error('Error in callFlutterBridge:', e);
  }
  return undefined;
};

export default callFlutterBridgeInterface;
